import * as THREE from "three";
import { addGrove, buildValley } from "./landscape.js";
import { createEnclaveTerrace } from "./baseTheme.js";

export const GRID_SIZE = 24;
export const CELL = 1;

/** A reclaimed terrace in a living valley, with a clearly bounded buildable surface. */
export function buildGround(): THREE.Group {
  const group = new THREE.Group();
  group.name = "ground";
  group.add(createEnclaveTerrace(GRID_SIZE));
  group.add(buildValley());
  addGrove(
    group,
    [-1, 1].flatMap((side) =>
      [-10, -6, -2, 2, 6, 10].map((p, i) => ({
        x: side * 14,
        z: p,
        y: -0.12,
        scale: 0.7 + (i % 3) * 0.12,
        autumn: i % 4 === 0,
      })),
    ),
  );
  return group;
}

/** Sky colour follows the same day/night blend as scene lighting. */
export function buildSky(): THREE.Mesh {
  const mat = new THREE.ShaderMaterial({
    side: THREE.BackSide,
    depthWrite: false,
    uniforms: { night: { value: 0 } },
    vertexShader: `varying vec3 vPos; void main(){ vPos = position; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`,
    fragmentShader: `uniform float night; varying vec3 vPos;
      void main(){ float h = smoothstep(-0.15, 0.8, normalize(vPos).y);
        vec3 day = mix(vec3(0.78,0.86,0.72), vec3(0.24,0.57,0.74), h);
        vec3 dusk = mix(vec3(0.12,0.23,0.29), vec3(0.025,0.07,0.16), h);
        gl_FragColor = vec4(mix(day,dusk,night),1.0);
        #include <tonemapping_fragment>
        #include <colorspace_fragment>
      }`,
  });
  const sky = new THREE.Mesh(new THREE.SphereGeometry(400, 24, 12), mat);
  sky.name = "sky";
  return sky;
}
